import { FC } from 'react';
import { motion, useAnimation } from 'framer-motion';
import {
  BsFillTelephoneFill as PhoneIcon,
  BsGithub as GithubIcon,
  BsLinkedin as LinkedinIcon,
  BsXLg as CloseMenuIcon,
} from 'react-icons/bs';
import { MdEmail as EmailIcon } from 'react-icons/md';

interface MobileNavigationProps {
  isOpen?: boolean;
  onClose?: () => void;
}

const MobileNavigation: FC<MobileNavigationProps> = ({ isOpen = false, onClose }) => {
  const handleNavigateByLink = (navigateToId: string) => {
    document.getElementById(navigateToId)?.scrollIntoView({ behavior: 'smooth' });
  };
  const contactsControls = useAnimation();

  return (
    <>
      <div
        className={`mobile-navigation-overlay ${isOpen ? 'mobile-navigation-overlay--open' : ''}`}
        onClick={onClose}
      />
      <div
        className={`mobile-navigation ${isOpen ? 'mobile-navigation--open' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="mobile-navigation__close-button" onClick={onClose} type="button">
          <CloseMenuIcon />
        </button>
        {['About', 'Skills', 'Career', 'Portfolio', 'Contact'].map((section) => (
          <button
            key={section}
            type="button"
            className="mobile-navigation__item"
            onClick={() => {
              handleNavigateByLink(section.toLowerCase());
              onClose?.();
            }}
          >
            {section}
          </button>
        ))}

        <ul className="mobile-navigation__contacts">
          <li>
            <motion.a
              animate={contactsControls}
              transition={{ duration: 2, delay: 0.5 }}
              href="mailto: achekanovskiy@gmail.com"
              className="mobile-navigation__contacts__item"
            >
              <div className="mobile-navigation__contacts__item__icon">
                <EmailIcon />
              </div>
              <div className="mobile-navigation__contacts__item__details">
                achekanovskiy@gmail.com
              </div>
            </motion.a>
          </li>
          <li>
            <motion.a
              animate={contactsControls}
              transition={{ duration: 2, delay: 0.7 }}
              href="https://www.linkedin.com/in/andrii-chekanovskyi-28413a1a1/"
              className="mobile-navigation__contacts__item"
            >
              <div className="mobile-navigation__contacts__item__icon">
                <LinkedinIcon />
              </div>
              <div className="mobile-navigation__contacts__item__details">
                https://www.linkedin.com/in/andrii-chekanovskyi-28413a1a1
              </div>
            </motion.a>
          </li>
          <li>
            <motion.a
              animate={contactsControls}
              transition={{ duration: 2, delay: 0.9 }}
              href="https://github.com/AndriyCh1"
              className="mobile-navigation__contacts__item"
            >
              <div className="mobile-navigation__contacts__item__icon">
                <GithubIcon />
              </div>
              <div className="mobile-navigation__contacts__item__details">
                https://github.com/AndriyCh1
              </div>
            </motion.a>
          </li>
          <li>
            <motion.a
              animate={contactsControls}
              transition={{ duration: 2, delay: 1.1 }}
              href="tel:17197993745"
              className="mobile-navigation__contacts__item"
            >
              <div className="mobile-navigation__contacts__item__icon">
                <PhoneIcon />
              </div>
              <div className="mobile-navigation__contacts__item__details">+17197993745</div>
            </motion.a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default MobileNavigation;
